import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  es: {
    // Navigation
    home: "Inicio",
    kosherFood: "Comida Kosher",
    shabbat: "Shabbat",
    contact: "Contáctanos",
    admin: "Admin",
    
    // Home page
    welcome: "Bienvenido a Guadalajara",
    welcomeSubtitle: "Jabad Guadalajara Copa Mundial 2026 - Tu hogar judío en México",
    
    // Main buttons
    kosherFoodTitle: "Comida Kosher",
    kosherFoodDesc: "Deliciosos platillos kosher con entrega a domicilio",
    shabbatTitle: "Shabbat",
    shabbatDesc: "Horarios y comidas comunitarias",
    contactTitle: "Estamos para ayudarte",
    contactDesc: "Contáctanos por WhatsApp",
    donationsTitle: "Donaciones",
    donationsDesc: "Tu generosidad hace la diferencia. Apoya a Jabad Guadalajara.",
    hotelsTitle: "Hoteles Recomendados",
    hotelsDesc: "Los mejores hoteles cerca de la comunidad para tu estancia.",
    attractionsTitle: "Atracciones",
    attractionsDesc: "Lugares imperdibles para visitar en Guadalajara y Jalisco.",
    
    // Kosher Food page
    menu: "Menú",
    ingredients: "Ingredientes",
    price: "Precio",
    addToCart: "Agregar",
    cart: "Carrito",
    emptyCart: "Tu carrito está vacío",
    total: "Total",
    subtotal: "Subtotal",
    checkout: "Proceder al pago",
    deliveryAddress: "Dirección de entrega",
    customerName: "Nombre",
    customerPhone: "Teléfono",
    customerEmail: "Email * (para confirmación)",
    notes: "Notas adicionales (opcional)",
    placeOrder: "Realizar pedido",
    orderSuccess: "¡Pedido realizado con éxito!",
    sendWhatsApp: "Enviar pedido por WhatsApp",
    processing: "Procesando...",
    payNow: "Pagar ahora",
    remove: "Quitar",
    quantity: "Cantidad",
    
    // Delivery options
    deliveryType: "Tipo de entrega",
    pickup: "Recoger en tienda",
    delivery: "Envío a domicilio",
    deliveryCost: "Costo de envío",
    free: "Gratis",
    selectZone: "Selecciona tu zona",
    pickupAddress: "Dirección de recogida",
    
    // Shabbat page
    shabbatSchedule: "Horarios de Shabbat",
    candleLighting: "Encendido de velas",
    havdalah: "Havdalá",
    prayers: "Rezos",
    shacharit: "Shajarit",
    mincha: "Minjá",
    meals: "Comidas",
    fridayDinner: "Cena de viernes",
    saturdayLunch: "Almuerzo de sábado",
    cost: "Costo",
    instructions: "Instrucciones para asistir",
    
    // Contact page
    contactUs: "Contáctanos",
    contactMessage: "¿Tienes alguna pregunta? Estamos aquí para ayudarte.",
    chatWhatsApp: "Chatear por WhatsApp",
    callUs: "Llamar",
    
    // Payment
    paymentSuccess: "¡Pago exitoso!",
    paymentSuccessMessage: "Tu pedido ha sido confirmado. Te enviaremos un mensaje con los detalles.",
    backToHome: "Volver al inicio",
    
    // Admin
    adminPanel: "Panel de Administración",
    menuManagement: "Gestión de Menú",
    shabbatManagement: "Gestión de Shabbat",
    ordersManagement: "Pedidos",
    save: "Guardar",
    edit: "Editar",
    delete: "Eliminar",
    addNew: "Agregar nuevo",
    
    // Common
    loading: "Cargando...",
    error: "Error",
    close: "Cerrar",
    confirm: "Confirmar",
    cancel: "Cancelar",
  },
  en: {
    // Navigation
    home: "Home",
    kosherFood: "Kosher Food",
    shabbat: "Shabbat",
    contact: "Contact Us",
    admin: "Admin",
    
    // Home page
    welcome: "Welcome to Guadalajara",
    welcomeSubtitle: "Jabad Guadalajara World Cup 2026 - Your Jewish home in Mexico",
    
    // Main buttons
    kosherFoodTitle: "Kosher Food",
    kosherFoodDesc: "Delicious kosher dishes with home delivery",
    shabbatTitle: "Shabbat",
    shabbatDesc: "Schedules and community meals",
    contactTitle: "We're here to help",
    contactDesc: "Contact us via WhatsApp",
    donationsTitle: "Donations",
    donationsDesc: "Your generosity makes a difference. Support Jabad Guadalajara.",
    hotelsTitle: "Recommended Hotels",
    hotelsDesc: "The best hotels near the community for your stay.",
    attractionsTitle: "Attractions",
    attractionsDesc: "Must-see places to visit in Guadalajara and Jalisco.",
    
    // Kosher Food page
    menu: "Menu",
    ingredients: "Ingredients",
    price: "Price",
    addToCart: "Add",
    cart: "Cart",
    emptyCart: "Your cart is empty",
    total: "Total",
    subtotal: "Subtotal",
    checkout: "Proceed to checkout",
    deliveryAddress: "Delivery address",
    customerName: "Name",
    customerPhone: "Phone",
    customerEmail: "Email * (for confirmation)",
    notes: "Additional notes (optional)",
    placeOrder: "Place order",
    orderSuccess: "Order placed successfully!",
    sendWhatsApp: "Send order via WhatsApp",
    processing: "Processing...",
    payNow: "Pay now",
    remove: "Remove",
    quantity: "Quantity",
    
    // Delivery options
    deliveryType: "Delivery type",
    pickup: "Store pickup",
    delivery: "Home delivery",
    deliveryCost: "Delivery cost",
    free: "Free",
    selectZone: "Select your zone",
    pickupAddress: "Pickup address",
    
    // Shabbat page
    shabbatSchedule: "Shabbat Schedule",
    candleLighting: "Candle lighting",
    havdalah: "Havdalah",
    prayers: "Prayers",
    shacharit: "Shacharit",
    mincha: "Mincha",
    meals: "Meals",
    fridayDinner: "Friday dinner",
    saturdayLunch: "Saturday lunch",
    cost: "Cost",
    instructions: "Instructions to attend",
    
    // Contact page
    contactUs: "Contact Us",
    contactMessage: "Do you have any questions? We're here to help.",
    chatWhatsApp: "Chat on WhatsApp",
    callUs: "Call us",
    
    // Payment
    paymentSuccess: "Payment successful!",
    paymentSuccessMessage: "Your order has been confirmed. We'll send you a message with the details.",
    backToHome: "Back to home",
    
    // Admin
    adminPanel: "Admin Panel",
    menuManagement: "Menu Management",
    shabbatManagement: "Shabbat Management",
    ordersManagement: "Orders",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    addNew: "Add new",
    
    // Common
    loading: "Loading...",
    error: "Error",
    close: "Close",
    confirm: "Confirm",
    cancel: "Cancel",
  },
  he: {
    // Navigation
    home: "בית",
    kosherFood: "אוכל כשר",
    shabbat: "שבת",
    contact: "צור קשר",
    admin: "ניהול",
    
    // Home page
    welcome: "ברוכים הבאים לגואדלחרה",
    welcomeSubtitle: "חב\"ד גואדלחרה מונדיאל 2026 - הבית היהודי שלך במקסיקו",
    
    // Main buttons
    kosherFoodTitle: "אוכל כשר",
    kosherFoodDesc: "מנות כשרות טעימות עם משלוח עד הבית",
    shabbatTitle: "שבת",
    shabbatDesc: "זמנים וארוחות קהילתיות",
    contactTitle: "אנחנו כאן לעזור",
    contactDesc: "צור קשר בוואטסאפ",
    donationsTitle: "תרומות",
    donationsDesc: "הנדיבות שלך עושה את ההבדל. תמכו בחב\"ד גואדלחרה.",
    hotelsTitle: "מלונות מומלצים",
    hotelsDesc: "המלונות הטובים ביותר ליד הקהילה לשהותך.",
    attractionsTitle: "אטרקציות",
    attractionsDesc: "מקומות שאסור לפספס בגואדלחרה ובחליסקו.",
    
    // Kosher Food page
    menu: "תפריט",
    ingredients: "מרכיבים",
    price: "מחיר",
    addToCart: "הוסף",
    cart: "עגלה",
    emptyCart: "העגלה שלך ריקה",
    total: "סה\"כ",
    subtotal: "סיכום ביניים",
    checkout: "המשך לתשלום",
    deliveryAddress: "כתובת למשלוח",
    customerName: "שם",
    customerPhone: "טלפון",
    customerEmail: "אימייל * (לאישור)",
    notes: "הערות נוספות (אופציונלי)",
    placeOrder: "בצע הזמנה",
    orderSuccess: "ההזמנה בוצעה בהצלחה!",
    sendWhatsApp: "שלח הזמנה בוואטסאפ",
    processing: "מעבד...",
    payNow: "שלם עכשיו",
    remove: "הסר",
    quantity: "כמות",
    
    // Delivery options
    deliveryType: "סוג משלוח",
    pickup: "איסוף מהחנות",
    delivery: "משלוח עד הבית",
    deliveryCost: "עלות משלוח",
    free: "חינם",
    selectZone: "בחר את האזור שלך",
    pickupAddress: "כתובת לאיסוף",
    
    // Shabbat page
    shabbatSchedule: "לוח זמני שבת",
    candleLighting: "הדלקת נרות",
    havdalah: "הבדלה",
    prayers: "תפילות",
    shacharit: "שחרית",
    mincha: "מנחה",
    meals: "ארוחות",
    fridayDinner: "ארוחת ליל שישי",
    saturdayLunch: "ארוחת צהריים של שבת",
    cost: "עלות",
    instructions: "הוראות להשתתפות",
    
    // Contact page
    contactUs: "צור קשר",
    contactMessage: "יש לך שאלות? אנחנו כאן לעזור.",
    chatWhatsApp: "שוחח בוואטסאפ",
    callUs: "התקשר אלינו",
    
    // Payment
    paymentSuccess: "התשלום הצליח!",
    paymentSuccessMessage: "ההזמנה שלך אושרה. נשלח לך הודעה עם הפרטים.",
    backToHome: "חזרה לדף הבית",
    
    // Admin
    adminPanel: "לוח ניהול",
    menuManagement: "ניהול תפריט",
    shabbatManagement: "ניהול שבת",
    ordersManagement: "הזמנות",
    save: "שמור",
    edit: "ערוך",
    delete: "מחק",
    addNew: "הוסף חדש",
    
    // Common
    loading: "טוען...",
    error: "שגיאה",
    close: "סגור",
    confirm: "אשר",
    cancel: "בטל",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('jabad-language');
    return saved || 'es';
  });

  useEffect(() => {
    localStorage.setItem('jabad-language', language);
    document.documentElement.dir = language === 'he' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const isRTL = language === 'he';

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
